import { gql } from '@apollo/client';
import {
  errorFragmentStr,
  textPairFragmentStr,
  labelValuePairFragmentStr,
  addressFragmentStr,
  shippingDetailsFragmentStr,
  billingInfoItemFragmentStr,
  billingInfoFragmentStr,
  vatDutyDetailsFragment,
  orderDetailsItemFragmentStr,
  transactionRowFragmentStr,
  transactionSummaryFragmentStr,
  orderItemsContainerFragmentStr,
  shippingAddressFragmentStr,
  stepFourFragmentStr,
  stepTwoFragmentStr,
  nextStepsFragmentStr,
  rneProductsFragmentStr,
  rneItemFragmentStr,
  productFragmentStr,
} from '../../query/fragmentStrings';

export const ORDER_DETAILS_QUERY = gql`
  query ORDER_DETAILS_QUERY($orderId : ID!, $email : String, $channel: String, $placedTime: String) {
    orderDetails(orderId : $orderId, email: $email, channel: $channel, placedTime: $placedTime) {
      orderDetailItems {
        ...order
        ...orderItemsContainer
      }
      success
      errors { ...error }
    }
    textFor {
      pleaseTryAgain: pair(pairKey: "pleaseTryAgain") { ...textPair }
      processingText: pair(pairKey: "processing") { ...textPair }
      successText: pair(pairKey: "success") { ...textPair }
      rneSummaryTitleText: pair(pairKey: "summaryText") { ...textPair }
      invalidOrderHeader: pair(pairKey: "invalidOrderHeader") { ...textPair }
      errorInvalidOrderContent: pair(pairKey: "errorInvalidOrderContent") { ...textPair }
    }
  }

  ${textPairFragmentStr}
  ${errorFragmentStr}
  ${labelValuePairFragmentStr}
  ${addressFragmentStr}
  ${shippingDetailsFragmentStr}
  ${billingInfoItemFragmentStr}
  ${billingInfoFragmentStr}
  ${vatDutyDetailsFragment}
  ${orderDetailsItemFragmentStr}
  ${transactionRowFragmentStr}
  ${transactionSummaryFragmentStr}
  ${orderItemsContainerFragmentStr}
  ${shippingAddressFragmentStr}
  ${stepFourFragmentStr}
  ${stepTwoFragmentStr}
  ${nextStepsFragmentStr}
  ${rneProductsFragmentStr}
  ${rneItemFragmentStr}
  ${productFragmentStr}
`;

export const RESEND_ORDER_CONFIRMATION_QUERY = gql`
 query RESEND_ORDER_CONFIRMATION_QUERY
  ($orderId: ID!, $isShipping: Boolean!, $packageNumber: String) {
    resendOrderConfirmation(orderId: $orderId, isShipping: $isShipping, packageNumber: $packageNumber) {
      status
    }
  }
`;
